import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import * as Routes from '@/modules/routes';

export interface OverviewTotals {
  attempted: number;
  accepted: number;
  refused_locally: number;
  success_rate: number | null;
}

export interface OverviewPayload {
  window: string;
  since: string;
  totals: OverviewTotals;
  by_status: Record<string, number>;
  by_platform: Record<string, number>;
  /** The teachers absorbing the most rejections — the overview's way in to a person. */
  teachers?: {
    staffer_id: number;
    name: string | null;
    subscriber: string | null;
    failures: number;
  }[];
}

const useSyncOverview = (window: string) => useQuery({
  queryFn: async (): Promise<OverviewPayload> => {
    const { data } = await axios.get(Routes.plato_api_sysadmin_grade_sync_overview_path(), {
      params: { window },
    });

    return data.data;
  },
  queryKey: ['gradeSyncOverview', window],
});

export default useSyncOverview;
